export default {
  initialize() {
    // attach to the global notifier
    this.notifier.push(this);

    this.addDisposable({
      dispose: () => {
        this.notifier.remove(this);
      },
    });
  },
  notify() {
    // OVERRIDE ME
  },
};
